/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_4_LInputs */

const en_mk_proof_4_l = /** @type {(inputs: Mk_Proof_4_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`review agent requests before approving the next step`)
};

const id_mk_proof_4_l = /** @type {(inputs: Mk_Proof_4_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tinjau permintaan agen sebelum menyetujui langkah berikutnya`)
};

/**
* | output |
* | --- |
* | "review agent requests before approving the next step" |
*
* @param {Mk_Proof_4_LInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_4_l = /** @type {((inputs?: Mk_Proof_4_LInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_4_LInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_4_l(inputs)
	return en_mk_proof_4_l(inputs)
});